import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import mapProps from 'recompose/mapProps';
import lifecycle from 'recompose/lifecycle';
import assoc from 'ramda/es/assoc';
import find from 'ramda/es/find';
import values from 'ramda/es/values';

import { advRefundedFetch } from 'app/actions/apps/advanceRefunded';
import { accountRemove } from 'app/common/actions/profile/remove';


const getText = (balance, refunded) => {
  if (balance) {
    return 'Удаление профиля не возможно, необходимо вернуть денежные средства';
  }
  if (refunded) {
    return 'Удаление профиля не возможно, необходимо отключить подписки и вернуть денежные средства"';
  }
  return 'Удаление профиля приведет к прекращению предоставления услуги. Денежные средства не будут возвращены за оплаченный период. Удалить профиль?';
};

const getButtons = (balance, refunded) => {
  if (balance || refunded) {
    return (['Закрыть', '']);
  }
  return (['Отмена', 'Удалить']);
};

const defaultState = {
  loading: true,
  isRefundedSubscribeExist: false,
};

export default compose(
  connect(
    state => ({
      parentBalance: parseFloat(state.financeBalance),
    })
  ),

  withState('state', 'setState', defaultState),

  withHandlers({
    handleRemove: ({ dispatch }) => (e) => {
      e.preventDefault();
      dispatch(accountRemove());
    },
  }),

  lifecycle({
    async componentDidMount() {
      const { dispatch, setState } = this.props;
      const res = await dispatch(advRefundedFetch());
      const isRefundedSubscribeExist = find(({
        subscriptions_exist: exist,
        advance_refunded: refunded,
      }) => (exist && refunded), values(res));
      setState(assoc('isRefundedSubscribeExist', isRefundedSubscribeExist));
      setState(assoc('loading', false));
    },
  }),

  mapProps(({
    parentBalance,
    state: { isRefundedSubscribeExist, ...remState },
    setState,
    ...props
  }) => ({
    ...props,
    ...remState,
    text: getText(parentBalance, isRefundedSubscribeExist),
    buttons: getButtons(parentBalance, isRefundedSubscribeExist),
  }))
);
